import React, { useState, useRef, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Formik, Form } from 'formik';
import { Toast } from 'primereact/toast';
import { classNames } from 'primereact/utils';
import axios from 'axios';

export default function AddConcentrationModal({ visible, onHide, products, loadProducts, loadConcentrations, fromProduct, selectedProduct }) {
    const [saving, setSaving] = useState(false);
    const [savingClose, setSavingClose] = useState(false);
    const [volumeUnits, setVolumeUnits] = useState([]);
    const [concentrationUnits, setConcentrationUnits] = useState([]);
    const toast = useRef(null);

    useEffect(() => {
        axios.get('/api/concentrations/units').then((response) => {
            const formattedOptions = response.data.map((unit) => ({
                label: unit.name,
                value: unit.name,
            }));
            setConcentrationUnits(formattedOptions);
        });

        axios.get('/api/volumes/units').then((response) => {
            const formattedOptions = response.data.map((unit) => ({
                label: unit.name,
                value: unit.name,
            }));
            setVolumeUnits(formattedOptions);
        });
    }, []);

    let initialValues = {
        product: selectedProduct ? selectedProduct.producto : null,
        concentration1: null,
        concentration2: null,
        concentration3: null,
        concentration_unit: 'mg/ml',
        volume: null,
        volume_unit: null,
        price: null,
    };

    if (fromProduct) {
        initialValues = {
            product: '',
            concentration1: null,
            concentration2: null,
            concentration3: null,
            concentration_unit: 'mg/ml',
            volume: null,
            volume_unit: null,
            price: null,
        };
    }

    const onConcentrationUnitChange = (e, values, handleChange) => {
        if (e.value == 'mg/ml') {
            values.concentration3 = null;
        } else {
            values.concentration1 = null;
            values.concentration2 = null;
        }

        handleChange({ target: { name: 'concentration_unit', value: e.value } });
    };

    const validateForm = (values) => {
        const errors = {};

        if (!values.product) {
            errors.product = 'Por favor selecciona un producto.';
        }
        if ((values.concentration1 == null || values.concentration2 == null) && (values.concentration_unit == 'mg/ml' || values.concentration_unit == null)) {
            errors.concentration1 = 'Por favor ingresa una concentración válida.';
        }
        if (values.concentration3 == null && values.concentration_unit != 'mg/ml') {
            errors.concentration3 = 'Por favor ingresa una concentración válida.';
        }
        if (!values.concentration_unit) {
            errors.concentration_unit = 'Por favor selecciona una unidad.';
        }
        if (!values.volume || values.volume <= 0) {
            errors.volume = 'El volumen debe ser mayor a 0.';
        }
        if (!values.volume_unit) {
            errors.volume_unit = 'Por favor selecciona una unidad.';
        }
        if (!values.price || values.price < 150) {
            errors.price = 'El precio debe ser mayor o igual a 150.';
        }

        return errors;
    };

    const saveData = (values, resetForm, closeModal = false) => {
        if (closeModal) {
            setSavingClose(true);
        } else {
            setSaving(true);
        }

        axios
            .post('/concentrations/newConcentration', {
                product: values.product,
                concentration: values.concentration3 ? values.concentration3 : `${values.concentration1} / ${values.concentration2}`,
                concentrationUnit: values.concentration_unit,
                volume: values.volume,
                volumeUnit: values.volume_unit,
                price: values.price,
            })
            .then(() => {
                /* 
                const selectedProduct = {
                    value: {product: values.product, codigo_producto: values.product.replace('/', '-')}
                }
                onProductChange(selectedProduct);
                */
                toast.current.show({ severity: 'success', detail: 'Guardado correctamente' });
                loadConcentrations(values.product.replace('/', '-'));
                loadProducts();
                resetForm();
                if (closeModal) onHide();
            })
            .catch(() => {
                toast.current.show({ severity: 'error', detail: 'Ha ocurrido un error al intentar grabar' });
            })
            .finally(() => {
                if (closeModal) {
                    setSavingClose(false);
                } else {
                    setSaving(false);
                }
            });
    };

    return (
        <Dialog visible={visible} onHide={onHide} header="Agregar Concentración" style={{ width: '90vw' }} modal className="p-fluid">
            <Toast ref={toast} position="bottom-right" />
            <Formik initialValues={initialValues} validate={validateForm} onSubmit={(values, { resetForm }) => saveData(values, resetForm)}>
                {({ values, handleChange, errors, touched, setTouched, resetForm, submitForm }) => (
                    <Form>
                        <div className="grid">
                            <div className="row justify-content-center">
                                <div className="col-12 col-lg-3 pb-4">
                                    <label htmlFor="product">Producto:</label>
                                    {fromProduct ? (
                                        <InputText
                                            id="product"
                                            name="product"
                                            value={values.product}
                                            onChange={handleChange}
                                            placeholder="Ingrese un producto"
                                            className={classNames({ 'p-invalid': touched.product && errors.product })}
                                        />
                                    ) : (
                                        <Dropdown
                                            editable
                                            id="product"
                                            name="product"
                                            value={values.product}
                                            options={products.slice(1).map((p) => ({ label: p.producto, value: p.producto }))}
                                            onChange={(e) => handleChange({ target: { name: 'product', value: e.value } })}
                                            placeholder="Seleccione o ingrese un producto"
                                            className={classNames({ 'p-invalid': touched.product && errors.product })}
                                        />
                                    )}
                                    <small className="p-error">{touched.product && errors.product}</small>
                                </div>

                                <div className="col-12 col-lg-4 pb-4">
                                    <label htmlFor="concentration1">Concentración:</label>
                                    <div className="row">
                                        {values.concentration_unit == 'mg/ml' ? (
                                            <>
                                                <div className="col-2 pe-0">
                                                    <InputNumber
                                                        id="concentration1"
                                                        name="concentration1"
                                                        value={values.concentration1}
                                                        onValueChange={(e) => handleChange({ target: { name: 'concentration1', value: e.value } })}
                                                        placeholder="10"
                                                        maxFractionDigits={2}
                                                        min={0}
                                                        className={classNames({ 'p-invalid': touched.concentration1 && errors.concentration1 })}
                                                    />
                                                </div>
                                                <span className="col-1 align-self-center text-center">/</span>
                                                <div className="col-2 ps-0">
                                                    <InputNumber
                                                        id="concentration2"
                                                        name="concentration2"
                                                        value={values.concentration2}
                                                        onValueChange={(e) => handleChange({ target: { name: 'concentration2', value: e.value } })}
                                                        placeholder="20"
                                                        maxFractionDigits={2}
                                                        min={0}
                                                        className={classNames({ 'p-invalid': touched.concentration2 && errors.concentration1 })}
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            <div className="col-6 col-md-5 pe-0">
                                                <InputNumber
                                                    id="concentration3"
                                                    name="concentration3"
                                                    value={values.concentration3}
                                                    onValueChange={(e) => handleChange({ target: { name: 'concentration3', value: e.value } })}
                                                    placeholder="10"
                                                    maxFractionDigits={2}
                                                    min={0}
                                                    className={classNames({ 'p-invalid': touched.concentration3 && errors.concentration3 })}
                                                />
                                            </div>
                                        )}
                                        <div className="col-6 col-md-7">
                                            <Dropdown
                                                id="concentration_unit"
                                                name="concentration_unit"
                                                value={values.concentration_unit}
                                                options={concentrationUnits}
                                                onChange={(e) => onConcentrationUnitChange(e, values, handleChange)}
                                                placeholder="Seleccione unidad"
                                                className={classNames({ 'p-invalid': touched.concentration_unit && errors.concentration_unit })}
                                            />
                                            {!errors.concentration1 && <small className="p-error">{errors.concentration_unit}</small>}
                                        </div>
                                    </div>
                                    <small className="p-error">{touched.concentration1 && errors.concentration1}</small>
                                    <small className="p-error">{touched.concentration3 && errors.concentration3}</small>
                                    {errors.concentration1 && (
                                        <>
                                            <br />
                                            <small className="p-error">{touched.concentration_unit && errors.concentration_unit}</small>
                                        </>
                                    )}
                                </div>

                                <div className="col-12 col-lg-3 pb-4">
                                    <label htmlFor="volume">Tamaño:</label>
                                    <div className="row justify-content-center">
                                        <div className="col-3">
                                            <InputNumber
                                                id="volume"
                                                name="volume"
                                                value={values.volume}
                                                onValueChange={(e) => handleChange({ target: { name: 'volume', value: e.value } })}
                                                placeholder="30"
                                                min={1}
                                                className={classNames({ 'p-invalid': touched.volume && errors.volume })}
                                            />
                                        </div>
                                        <div className="col-9">
                                            <Dropdown
                                                id="volume_unit"
                                                name="volume_unit"
                                                value={values.volume_unit}
                                                options={volumeUnits}
                                                onChange={(e) => handleChange({ target: { name: 'volume_unit', value: e.value } })}
                                                placeholder="Seleccione unidad"
                                                className={classNames({ 'p-invalid': touched.volume_unit && errors.volume_unit })}
                                            />
                                            {!errors.volume && <small className="p-error">{touched.volume_unit && errors.volume_unit}</small>}
                                        </div>
                                    </div>
                                    <small className="p-error">{touched.volume && errors.volume}</small>
                                    {errors.volume && (
                                        <>
                                            <br />
                                            <small className="p-error">{touched.volume_unit && errors.volume_unit}</small>
                                        </>
                                    )}
                                </div>

                                <div className="col-12 col-lg-2 pb-4">
                                    <label htmlFor="price">Precio:</label>
                                    <div className="flex align-items-center">
                                        <span className="pr-2">$ </span>
                                        <InputNumber
                                            id="price"
                                            name="price"
                                            value={values.price}
                                            onValueChange={(e) => handleChange({ target: { name: 'price', value: e.value } })}
                                            placeholder="55000"
                                            min={150}
                                            className={classNames({ 'p-invalid': touched.price && errors.price }, 'col-10')}
                                        />
                                    </div>
                                    <small className="p-error">{touched.price && errors.price}</small>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="mt-2 col-4 col-md-2 mb-2 text-center">
                                    <Button
                                        label="Guardar"
                                        type="button"
                                        className="p-button-secondary"
                                        loading={saving}
                                        onClick={async () => {
                                            const errors = await validateForm(values);
                                            setTouched({
                                                product: true,
                                                concentration1: true,
                                                concentration2: true,
                                                concentration3: true,
                                                concentration_unit: true,
                                                volume: true,
                                                volume_unit: true,
                                                price: true,
                                            });
                                            if (!Object.keys(errors).length) submitForm();
                                        }}
                                    />
                                </div>
                                <div className="mt-2 col-4 col-md-2 mb-2 text-center">
                                    <Button
                                        label="Guardar y Cerrar"
                                        type="button"
                                        className="p-button-secondary"
                                        loading={savingClose}
                                        onClick={async () => {
                                            const errors = await validateForm(values);
                                            setTouched({
                                                product: true,
                                                concentration1: true,
                                                concentration2: true,
                                                concentration3: true,
                                                concentration_unit: true,
                                                volume: true,
                                                volume_unit: true,
                                                price: true,
                                            });
                                            if (!Object.keys(errors).length) saveData(values, resetForm, true);
                                        }}
                                    />
                                </div>
                                <div className="mt-2 col-4 col-md-2 mb-2 text-center">
                                    <Button label="Cerrar" type="button" className="p-button" onClick={onHide} />
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
